import React from 'react';
import { useRoutes } from 'react-router-dom';
import LoginPage from '../pages/auth/LoginPage';
import ErrorPage from '../pages/errors/ErrorPage';

const AuthRoutes = () => {
  return useRoutes([
    {
      index: true,
      path: '',
      element: <LoginPage />
    },
    {
      index: false,
      path: '*',
      element: <ErrorPage />
    }
  ]);
};

export default AuthRoutes;
